import { preset } from './preset';

export const Prime = {
  preset,
};
